import { Component } from '@angular/core';

@Component({
  templateUrl: './home.page.html',
})
/**
 * Home Page
 */
export class HomePage {}
